module.exports = __webpack_public_path__ + "img/download-1.0f82370f.png";